var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errorMsg)?_c('article',{staticClass:"message is-danger mb-0"},[_c('div',{staticClass:"message-body"},[_c('strong',[_vm._v(_vm._s(_vm.errorMsg))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }